import {defineStore} from "pinia";
import {io} from "socket.io-client";
import {useGlobalStore} from "@/stores/global";
const socketIo = io("https://api.baranimes.com", {
  withCredentials: true,
});

export const useJoinRoomStore = defineStore("join_room", () => {
  const global = useGlobalStore();
  var socket = socketIo;
  function joinRoom(to) {
    const userLocale = navigator.language || navigator.userLanguage;
    const userCountryCode = new Intl.Locale(userLocale).region;
    global.joinRoom = true;
    socket.emit("join_room", {
      id: to,
      region: userCountryCode,
    });
  }
  function leaveRoom() {
    global.joinRoom = false;
    socket.emit("leave_room");
  }

  return {joinRoom, leaveRoom, socket};
});
